<template>
  <Dialog ref="dialog">
    <div class="panel panel-collapse">
      <div class="panel__content">
        <div class="panel__heading">
          <h2>Send Email</h2>
        </div>
        <form class="form" @submit="sendVerificationEmail" autocomplete="off">
          <div class="form-group">
            <label class="form-label">Confirm Email Address:
              <input v-model="formData.email" class="form-control">
            </label>
          </div>
          <div class="form-group">
            <label class="form-label">Subject Line:
              <input v-model="formData.subject" class="form-control">
            </label>
          </div>
          <div class="form-group">
            <label class="form-label">Message:
              <textarea v-model="formData.message" class="form-control form-control--textarea" rows="20"></textarea>
            </label>
          </div>
          <div class="buttons">
            <button type="submit" class="btn btn--primary"
                    :disabled="formData.email == null || formData.subject == null || formData.message == null">
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from './Dialog';
import api from '@/api';

export default {
  props: {
    customerId: {
      type: Number
    },
    name: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
  },
  name: 'CustomerEmail',
  components: {
    Dialog
  },
  methods: {
    sendVerificationEmail(e) {
      e.preventDefault();

      api.sendEmail({
        email: this.formData.email,
        subject: this.formData.subject,
        content: this.formData.message,
        customer_id: this.customerId.toString()
      }).catch(err => {
        console.warn(err);
      });

      this.$refs.dialog.$el.classList.remove('show');
    }
  },
  data() {
    return {
      formData: {
        email: this.email,
        subject: 'Action Required: Verify Your Account Information',
        message: `${this.name},

To ensure you continue to receive Aimé Leon Dore product deliveries, please click the link below to verify or update your personal information. This will assist us in staying up-to-date on your sizing and delivery preferences.

If you have any questions please contact us at the number provided below.

Thank you,
Aimé Leon Dore
+1 (347) 502-1068`
      }
    }
  }
}
</script>